import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Row,
  Col,
  Select,
  InputNumber,
  Button,
  Space,
  useSelect,
  Collapse,
  Typography,
  Descriptions,
  Create,
  useForm,
  PageHeader,
  Breadcrumb,
  Icons,
  Divider,
  Radio,
  RadioChangeEvent,
  Table,
  Card,
  Tag,
  DateField,
  // Badge,
  ErrorComponent,
  useModal,
} from '@pankod/refine-antd'
import { Badge, Tabs } from 'antd'
import { useCreate, useCreateMany, useGetIdentity, useList, useMany, useNavigation, useOne, useTable, useUpdate } from '@pankod/refine-core'
import { MinusCircleOutlined, PlusOutlined, CaretRightOutlined } from '@ant-design/icons'
import {
  IProduct,
  ITestTrack,
  ISection,
  ITopic,
  ITheme,
  ISubTheme,
  ISubject,
  IPaperTemplateSubSection,
  IPaperTemplate,
  IQuestion,
  IPaper,
  IQuestionUsageAnalysis,
  INotification,
  IPaperUsageAnalysis,
  ITestEventAssignedPapers,
  IPaperMCQQuestions,
  IQuestionSnapshots,
} from 'interfaces'
import ReactMarkdown from 'react-markdown'
import { PaperUsageAnalysis } from 'components/paperUsageAnalysis'
import { ExportModal } from './exportPaperModal'
import { ShuffleMCQOptions } from './shuffleMCQoptions'

import { useEffect, useState } from 'react'
import paperTemplateSubSectionMetaData from 'metadata/paperTemplateSubSections'
import paperTemplateMetaData from 'metadata/paperTemplate'

import paperMetaData from 'metadata/paper'
import questionMetaData from 'metadata/questions'
import paperMCQMetaData from 'metadata/paper_mcq_questions'

import { nhost } from 'utility'
import { Data } from 'react-csv/components/CommonPropTypes'
import { getCandidateUsageCountByPaperId, getQuestionsAndOptions } from 'gql/query'
import { createNotificationPaperApproved, createNotificationPaperForApproval } from 'gql/mutations'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import { CheckUserAccess } from 'components/accessability'
import { DiscriminationIndexFromPaper } from './discriminationIndexFromPaper'
import CleanupQuestionsList from './cleanupQuestions'
import RichTextRender from 'components/questions/rich_text_render'
import he from 'he'
import { mediaPlaceholdersFrom, stripMediaTags } from 'helpers/question/media'
const { Text, Link, Title } = Typography

const { Panel } = Collapse
const { ExportOutlined, ArrowDownOutlined, WarningOutlined } = Icons

type Permission = {
  granted?: boolean | undefined
}

export const ShowPaper: React.FC = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const { userRole, productManagerList } = useUserContext()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [errorCode, setErrorCode] = useState<number>(200)
  const { edit, show, push } = useNavigation()
  const [paperStatus, setPaperStatus] = useState('')
  const [questionCreated, setQuestionCreated] = useState(0)
  const [flaggedQuestions, setFlaggedQuestions] = useState<string[]>([])
  const [assignedQuestions, setAssignedQuestions] = useState<string[]>([])
  const [questionsCreated, setQuestionsCreated] = useState(0)
  const [approverFeedback, setApproverFeedback] = useState<any>([])
  const [rejectedQuestions, setRejectedQuestions] = useState<string[]>([])
  const [rejectedQuestionsFlag, setRejectedQuestionsFlag] = useState<boolean>(true)
  const [paperQuestionData, setPaperQuestionData] = useState<IQuestion[] | undefined>(undefined)
  const [hasRetiredQuestions, setHasRetiredQuestions] = useState<boolean>(false)
  const [hasCleanupWindowQuestions, setHasCleanupWindowQuestions] = useState<boolean>(false)

  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})

  const { mutateAsync: createNotification } = useCreateMany<INotification>()

  const { mutate } = useUpdate<IPaperTemplate>()
  const { mutate: mutateQuestionUsageAnalysis } = useCreateMany<IQuestionUsageAnalysis>()
  const { mutateAsync: mutatePaperStatus } = useUpdate<IPaper>()

  const { mutate: mutatePaperUsageAnalysis } = useCreate<IPaperUsageAnalysis>()
  const { show: showExportModal, close: closeExportModal, modalProps: exportModalProps } = useModal()
  const { show: showMCQShuffleModal, close: closeMCQShuffleModal, modalProps: mcqShuffleModalProps } = useModal()
  const { show: showDIModal, close: closeDIModal, modalProps: DIModalProps } = useModal()

  const { formProps, saveButtonProps, queryResult } = useForm<IPaper>({ action: 'edit', metaData: paperMetaData })
  const record = queryResult?.data?.data
  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const [paperTemplateData, setPaperTemplateData] = useState<IPaperTemplate>()
  const [paperTemplateSubSectionData, setPaperTemplateSubSectionData] = useState<IPaperTemplateSubSection[]>()
  const [subSectionQuestions, setSubSectionQuestions] = useState<any>()

  const [exportData, setExportData] = useState<string | Data | (() => string | Data)>('')
  const [exportDataLoading, setExportDataLoading] = useState<boolean>(true)
  // const [currentActiveKey, setCurrentActiveKey] = useState<string>('same_event')
  // const [eventDetailsForExport, setEventDetailsForExport] = useState<ITestEventAssignedPapers>()

  const [optionsBalanced, setOptionsBalanced] = useState<boolean>(false)
  const [candidatesUsedCount, setCandidatesUsedCount] = useState<number>(0)
  const { data: mcqOptionsQueryResult, refetch: refetchMcq } = useList<IPaperMCQQuestions>({
    resource: 'paper_mcq_questions',
    metaData: paperMCQMetaData,
    queryOptions: { enabled: !!record, staleTime: Infinity },
    config: { filters: [{ field: 'paper_id', operator: 'eq', value: record?.id }] },
  })
  const mcqQuestionsCorrectOptionsList = mcqOptionsQueryResult?.data
  const totalFilledQuestionCount = record?.subSectionQuestions
    ? record?.subSectionQuestions?.reduce((count: number, item: any) => count + (item?.questionIds?.length || 0), 0)
    : 0
  const slotData = record?.slot_data && JSON.parse(record?.slot_data)
  const priorityList =
    record?.product?.type === 'jharkhand'
      ? [
          'Subject Expertise (SE)',
          'Pedagogical Content Knowledge (PCK)',
          'General Pedagogy (GP)',
          'Continuous and Comprehensive Evaluation (CCE)',
          'Teacher Perspectives and Professional Competencies (TP&PC)',
        ]
      : ['Subject Expertise (SE)', 'Pedagogical Content Knowledge (PCK)', 'General Pedagogy (GP)', 'Professional and core competencies (PC)']

  useEffect(() => {
    let questions_count = 0
    let _assignedQuestions: string[] = []
    let _flaggedQuestions = [...flaggedQuestions]
    let _approverFeedback = [...approverFeedback]
    let _rejectedQuestionsFlag = false
    subSectionQuestions?.forEach((item: any) => {
      _assignedQuestions = _assignedQuestions.concat(item?.questionIds)
      item?.questionIds?.forEach((questionId: any) => {
        if (questionId !== '') questions_count++
        if (rejectedQuestions.includes(questionId)) _rejectedQuestionsFlag = true
      })
    })
    setQuestionsCreated(questions_count)
    setAssignedQuestions(_assignedQuestions)
    setRejectedQuestionsFlag(_rejectedQuestionsFlag)
    //Resretting flagged question status to only selected questions
    _flaggedQuestions = _flaggedQuestions.filter(item => _assignedQuestions?.includes(item))
    setFlaggedQuestions(_flaggedQuestions)

    //Resetting approver feedback to only selected questions
    _approverFeedback = _approverFeedback.filter(item => _assignedQuestions?.includes(item?.questionId))
    setApproverFeedback(_approverFeedback)
  }, [subSectionQuestions])

  const { modalProps: cleanupQuestionModalProps, close: closeCleanupQuestions, show: showCleanupQuestions } = useModal()

  const { data: paperTemplate } = useOne<IPaperTemplate>({
    resource: 'paper_templates',
    id: record?.paper_template_id!,
    metaData: paperTemplateMetaData,
    queryOptions: {
      enabled: !!record?.paper_template_id,
    },
  })

  const paperTemplateSections = useMany<ISection>({
    resource: 'sections',
    ids: sectionListIds,
    queryOptions: {
      enabled: !!sectionListIds,
    },
    metaData: {
      fields: ['id', 'name'],
    },
  })

  if (paperTemplateSections?.data) {
    paperTemplateSections.data.data = paperTemplateSections.data.data?.sort((a: any, b: any) => {
      const indexA = priorityList.indexOf(a.name)
      const indexB = priorityList.indexOf(b.name)
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
    })
  }
  const paperTemplateSubSections = useList<IPaperTemplateSubSection>({
    resource: 'paper_template_sub_sections',
    config: {
      filters: [
        {
          field: 'paper_template_id',
          operator: 'eq',
          value: record?.paper_template_id!,
        },
      ],
      sort: [
        {
          field: 'mark_per_question',
          order: 'asc',
        },
      ],
      pagination:{pageSize:1000} //added this pagination to handle the page show if more than 10 subsection
    },
    queryOptions: {
      enabled: !!record?.paper_template_id,
    },
    metaData: paperTemplateSubSectionMetaData,
  })

  useEffect(() => {
    if (!record?.id) return
    getCandidateUsageCountByPaperId(record.id).then(setCandidatesUsedCount)
  }, [record?.id])

  // const { tableQueryResult: listOfEventsQueryResult } = useTable<ITestEventAssignedPapers>({
  //   resource: 'test_event_assigned_papers',
  //   metaData: testEventAssignedPapersMetaData,
  //   permanentFilter: [
  //     { field: 'paper_id', operator: 'eq', value: record?.id },
  //     { field: 'active', operator: 'eq', value: true },
  //   ],
  //   queryOptions: { enabled: !!record?.id },
  // })

  const disableEditButton = (paperStatus: any, record: IPaper | undefined): boolean => {
    if (record?.paper_request?.status === 'Closed') return true
    if (paperStatus === 'Approved' || paperStatus === 'Rejected') return true
    if (paperStatus === 'For Approval') {
      if (userRole === 'papersetter') {
        return true
      } else if (userRole === 'paperapprover' || userRole === 'admin') return false
    }
    if (userRole === 'productmanager') return true
    return false
  }

  const fetchExportData = async (isHtml: boolean = false) => {
    try {
      let data = ''
      let count = 1
      let allQuestionIds: any = []
      const paperQuestions = record?.questionAnswerKeys
      subSectionQuestions?.forEach((subSection: any) => {
        if (subSection?.questionIds) allQuestionIds = allQuestionIds.concat(subSection?.questionIds)
      })

      let questionAndOptions: any = []
      allQuestionIds = JSON.stringify(allQuestionIds)
      if (record?.status === 'Approved') {
        const getDetailsFromQuestionCopyTable = await getQuestionsAndOptions(allQuestionIds, record?.id)
        if (getDetailsFromQuestionCopyTable && getDetailsFromQuestionCopyTable.length > 0) {
          const flattenedQuestionOptionsArray = getDetailsFromQuestionCopyTable.map((item: any) => {
            const { question, ...rest } = item
            return {
              ...rest,
              ...question,
            }
          })
          questionAndOptions = flattenedQuestionOptionsArray && flattenedQuestionOptionsArray.length > 0 ? flattenedQuestionOptionsArray : []
        }
      }

      questionAndOptions = questionAndOptions.length <= 0 ? await getQuestionsAndOptions(allQuestionIds) : questionAndOptions
      setPaperQuestionData(questionAndOptions)
      subSectionQuestions?.forEach((subSection: any) => {
        const subSectionDetails = paperTemplateSubSectionData?.find((item: any) => subSection?.id === item?.id)
        const isBilingual = subSectionDetails?.base_lang && subSectionDetails?.target_lang ? true : false
        // const subSectionDetails = paperTemplateSubSectionData?.filter((item: any) => subSection?.id === item?.id)[0]
        let sectionName = '<p>' + subSectionDetails?.section?.name.replace(/,/g, '!@!') + '</p>'
        let subSectionName = '<p>' + subSectionDetails?.name.replace(/,/g, '!@!') + '</p>'
        let themeName = subSectionDetails?.theme?.name ? '<p>' + subSectionDetails?.theme?.name.replace(/,/g, '!@!') + '</p>' : ''
        let subTheme = subSectionDetails?.sub_theme?.name ? '<p>' + subSectionDetails?.sub_theme?.name.replace(/,/g, '!@!') + '</p>' : ''
        let topicName = subSectionDetails?.topic?.name ? '<p>' + subSectionDetails?.topic?.name.replace(/,/g, '!@!') + '</p>' : ''
        // const row1 = `\nSection name,${subSectionDetails?.section?.name}`
        const row1 = `\nSection name,${sectionName}`
        data = data.concat(row1)
        // const row2 = `\nSub Section name,${subSectionDetails?.name},,Theme,${subSectionDetails?.theme?.name},,Sub Theme,${subSectionDetails?.sub_theme?.name},,Topic,${subSectionDetails?.topic?.name},,Marks per question,${subSectionDetails?.mark_per_question}`
        const row2 = `\nSub Section name,${subSectionName},,Theme,${themeName},,Sub Theme,${subTheme},,Topic,${
          topicName ? topicName : ''
        },,Marks per question,${subSectionDetails?.mark_per_question}`
        data = data.concat(row2)
        subSection?.questionIds?.forEach((item: string) => {
          const questionObject = questionAndOptions?.filter((questionOptionsObj: any) => questionOptionsObj?.id === item)[0]
          let questionEvaluationNumber = paperQuestions.find((item: any) => questionObject.id === item.id)
          let questionNumber = questionEvaluationNumber?.number
          if (questionObject) {
            questionObject.title = isHtml
              ? isBilingual && questionObject?.questionByTransilationOf?.title
                ? questionObject?.questionByTransilationOf?.title
                    .replace(/।\s*(<br\s*\/?>)/gi, '। $1')
                    .replace(/(<br\s*\/?>\s*){2,}/gi, '<br/><br/>') +
                  '<br/><br/>' +
                  questionObject.title.replace(/।\s*(<br\s*\/?>)/gi, '। $1').replace(/(<br\s*\/?>\s*){2,}/gi, '<br/><br/>')
                : questionObject.title.replace(/।\s*(<br\s*\/?>)/gi, '। $1').replace(/(<br\s*\/?>\s*){2,}/gi, '<br/><br/>')
              : isBilingual && questionObject?.questionByTransilationOf?.title
              ? questionObject?.questionByTransilationOf?.title
                  .replace(/<strong>/g, '[b]')
                  .replace(/<\/strong>/g, '[/b]')
                  .replace(/<u>/g, '[u]')
                  .replace(/<\/u>/g, '[/u]')
                  .replace(/<em>/g, '[i]')
                  .replace(/<\/em>/g, '[/i]') +
                '[br][br]' +
                questionObject?.title
                  .replace(/<strong>/g, '[b]')
                  .replace(/<\/strong>/g, '[/b]')
                  .replace(/<u>/g, '[u]')
                  .replace(/<\/u>/g, '[/u]')
                  .replace(/<em>/g, '[i]')
                  .replace(/<\/em>/g, '[/i]')
              : questionObject?.title
                  .replace(/<strong>/g, '[b]')
                  .replace(/<\/strong>/g, '[/b]')
                  .replace(/<u>/g, '[u]')
                  .replace(/<\/u>/g, '[/u]')
                  .replace(/<em>/g, '[i]')
                  .replace(/<\/em>/g, '[/i]')

            // questionObject.title = isHtml
            //   ?
            //     questionObject.title.replace(/।\s*(<br\s*\/?>)/gi, '। $1').replace(/(<br\s*\/?>\s*){2,}/gi, '<br/><br/>')
            //   : questionObject?.title
            //       .replace(/<strong>/g, '[b]')
            //       .replace(/<\/strong>/g, '[/b]')
            //       .replace(/<u>/g, '[u]')
            //       .replace(/<\/u>/g, '[/u]')
            //       .replace(/<em>/g, '[i]')
            //       .replace(/<\/em>/g, '[/i]')
            const text = new DOMParser().parseFromString(questionObject?.title, 'text/html')
            let imageInclude: any = ''
            if (isBilingual) {
              const imageElements = text?.body.querySelectorAll('img') || []
              const imageSources = Array.from(imageElements).map(img => img.src)
              if (imageSources && imageSources.length > 0) {
                imageInclude = imageSources[imageSources.length - 1]
              }
            } else {
              imageInclude = text?.body.querySelector('img')?.src
            }
            // Printed papers can't play media, so audio/video is swapped for a labelled box.
            const titleMediaPlaceholders = mediaPlaceholdersFrom(text?.body)

            if (text.body.textContent || imageInclude || titleMediaPlaceholders) {
              let pTagRemovedValue =
                isHtml && questionObject?.title
                  ? stripMediaTags(questionObject?.title).replace(/,/g, '!@!').replace(/""/g, '"')
                  : text.body.textContent
                  ? text.body.textContent
                      .replace(/,/g, '!@!')
                      .replace(/"/g, "''")
                      .replace(/\[br\]\[br\]/g, '<br/><br/>')
                  : ''
              if (imageInclude) {
                pTagRemovedValue = `${pTagRemovedValue} <img src='${imageInclude}'>`
              }
              if (titleMediaPlaceholders) {
                pTagRemovedValue = `${pTagRemovedValue} ${titleMediaPlaceholders}`
              }
              const pAddedAtEndAndTop = '<p>' + pTagRemovedValue + '</p>'
              questionObject.title = he.decode(pAddedAtEndAndTop)
            }
          }
          const shuffledOptions = mcqQuestionsCorrectOptionsList?.filter((data: any) => data?.question_id === questionObject?.id)[0]
          if (shuffledOptions !== undefined) {
            questionObject['option_details'] = shuffledOptions['option_details']
          }
          const row3 = `\n${questionNumber},${questionObject?.title?.replace(/\n/g, '')},,Question_Id,${questionObject.question_id},\n`
          data = data.concat(row3)
          let optionDetails = ''
          interface alphabetsType {
            [key: number]: string
          }
          const alphabets: alphabetsType = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h' }
          if (questionObject?.question_type_id === 'MCQ') {
            questionObject?.option_details?.forEach((option: any, idx: number) => {
              // option.option_text = isHtml
              //   ? option.option_text
              //   : option.option_text
              //       .replace(/<strong>/g, '[b]')
              //       .replace(/<\/strong>/g, '[/b]')
              //       .replace(/<u>/g, '[u]')
              //       .replace(/<\/u>/g, '[/u]')
              //       .replace(/<em>/g, '[i]')
              //       .replace(/<\/em>/g, '[/i]')
              option.option_text = isHtml
                ? isBilingual && questionObject?.questionByTransilationOf?.option_details[idx]?.option_text
                  ? questionObject?.questionByTransilationOf?.option_details[idx]?.option_text + '<br/><br/>' + option?.option_text
                  : option.option_text
                : isBilingual && questionObject?.questionByTransilationOf?.option_details[idx]?.option_text
                ? questionObject?.questionByTransilationOf?.option_details[idx]?.option_text
                    .replace(/<strong>/g, '[b]')
                    .replace(/<\/strong>/g, '[/b]')
                    .replace(/<u>/g, '[u]')
                    .replace(/<\/u>/g, '[/u]')
                    .replace(/<em>/g, '[i]')
                    .replace(/<\/em>/g, '[/i]') +
                  '[br][br]' +
                  option?.option_text
                    .replace(/<strong>/g, '[b]')
                    .replace(/<\/strong>/g, '[/b]')
                    .replace(/<u>/g, '[u]')
                    .replace(/<\/u>/g, '[/u]')
                    .replace(/<em>/g, '[i]')
                    .replace(/<\/em>/g, '[/i]')
                : option.option_text
                    .replace(/<strong>/g, '[b]')
                    .replace(/<\/strong>/g, '[/b]')
                    .replace(/<u>/g, '[u]')
                    .replace(/<\/u>/g, '[/u]')
                    .replace(/<em>/g, '[i]')
                    .replace(/<\/em>/g, '[/i]')
              let optionTextFromDom = new DOMParser().parseFromString(option?.option_text, 'text/html')
              let optionImageInclude = optionTextFromDom?.body.querySelector('img')?.src
              const optionMediaPlaceholders = mediaPlaceholdersFrom(optionTextFromDom?.body)
              let optionTextRemoveLineBreak =
                isHtml && option?.option_text
                  ? stripMediaTags(option.option_text)
                      .replace(/\n/g, '<br/>')
                      .replace(/,/g, '!@!')
                      .replace(/""/g, '"')
                      .replace(/(<br\s*\/?>\s*){2,}/gi, '<br/>')
                  : optionTextFromDom.body.textContent
                  ? optionTextFromDom.body.textContent.replace(/\n/g, '').replace(/,/g, '!@!').replace(/"/g, "''").replace(/\[br\]\[br\]/g, '<br/><br/>')
                  : ''
              let isImageAddedOption = optionImageInclude
                ? `${optionTextRemoveLineBreak ? optionTextRemoveLineBreak : ''} <img src='${optionImageInclude}'>`
                : `${optionTextRemoveLineBreak}`
              if (optionMediaPlaceholders) {
                isImageAddedOption = `${isImageAddedOption} ${optionMediaPlaceholders}`
              }
              let optionText = isImageAddedOption !== '' || isImageAddedOption !== undefined ? '<p>' + isImageAddedOption + '</p>' : ''
              optionText = he.decode(optionText)
              optionDetails = optionDetails.concat(`${alphabets[idx + 1]},${optionText},${option?.option_flag}`)
            })
            data = data.concat(`${optionDetails}`)
          }
          if (questionObject?.question_type_id === 'Match') {
            questionObject?.option_details?.forEach((option: any) => {
              option.left_label_text = option.left_label_text
                .replace(/<strong>/g, '[b]')
                .replace(/<\/strong>/g, '[/b]')
                .replace(/<u>/g, '[u]')
                .replace(/<\/u>/g, '[/u]')
                .replace(/<em>/g, '[i]')
                .replace(/<\/em>/g, '[/i]')
              option.right_label_text = option.right_label_text
                .replace(/<strong>/g, '[b]')
                .replace(/<\/strong>/g, '[/b]')
                .replace(/<u>/g, '[u]')
                .replace(/<\/u>/g, '[/u]')
                .replace(/<em>/g, '[i]')
                .replace(/<\/em>/g, '[/i]')
              optionDetails = optionDetails.concat(`,${option?.left_label_text},${option?.right_label_text}`)
            })
            data = data.concat(`${optionDetails} \n`)
          }
          count++
        })
      })
      if (isHtml) {
        setExportDataLoading(false)
        return data
      }
      setExportData(data)
      setExportDataLoading(false)
    } catch (err) {
      console.log(err, 'error of fetching export data')
    }
  }

  const handleDisablePaperCondition = (record: IPaper | undefined) => {
    let activeEvents = false
    record?.test_events_assigned?.forEach(assignedEvent => {
      if (assignedEvent?.active) activeEvents = true
    })
    return activeEvents
  }

  const handleOnFinish = async (status: string) => {
    setPaperStatus(status)
    if (status === 'For Approval') {
      const paperApproverId = record?.paper_request?.paper_approver_id
      const paperRequest = record?.paper_request
      paperApproverId && createNotificationPaperForApproval(user?.id, paperApproverId, paperRequest, record?.id)
      //include email notification here
    }

    if (status === 'Approved') {
      const productManagerDetails = productManagerList?.filter(
        (data: { id: string; displayName: string; email: string }) => data?.id === record?.paper_request?.created_by
      )[0]
      let notification = {
        description: `paper ${record?.paper_smart_id} has been approved for the paper request ${record?.paper_request?.name}`,
        sender: user?.id,
        recepient: productManagerDetails?.user?.id,
        source_name: 'papers',
        title: 'Paper Approved',
        recepient_user_role: 'productmanager',
        redirect_component: 'show',
        redirect_id: record?.id,
      }

      await createNotification({ resource: 'notifications', values: [{ ...notification }] })

      // paperSetterId && createNotificationPaperApproved(user?.id, paperSetterId, paperRequest, record?.id)
      let _mutationObj: any[] = []
      subSectionQuestions.forEach((item: any) => {
        const subSectionDetails = paperTemplateSubSectionData?.filter(subSection => subSection?.id === item?.id)[0]
        item?.questionIds?.forEach((questionId: string) => {
          _mutationObj.push({
            question_id: questionId,
            paper_id: record?.id,
            test_event_id: record?.test_event_id,
            section_id: subSectionDetails?.section_id,
          })
        })
      })
      mutateQuestionUsageAnalysis({
        resource: 'question_usage_analysis',
        values: _mutationObj,
      })
    }
    formProps?.form?.submit()
  }

  // const changeTab = (activeKey:any) => {
  //   console.log({activeKey});
  //     setCurrentActiveKey(activeKey)

  // };

  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        updated_by: values?.updated_by,
        status: paperStatus,
      })
    )
  }

  useEffect(() => {
    if (subSectionQuestions && paperTemplateSubSectionData) fetchExportData()
  }, [subSectionQuestions, paperTemplateSubSectionData, mcqQuestionsCorrectOptionsList])

  useEffect(() => {
    if (paperTemplate?.data) {
      setPaperTemplateData(paperTemplate?.data)
      setSectionListIds(paperTemplate?.data?.sections)
    }
  }, [paperTemplate?.data])

  useEffect(() => {
    if (paperTemplateSubSections?.data?.data) setPaperTemplateSubSectionData(paperTemplateSubSections?.data?.data || [])
  }, [paperTemplateSubSections?.data?.data])

  useEffect(() => {
    if (record?.status) setPaperStatus(record?.status)
    if (record?.flagged_questions) setFlaggedQuestions(record?.flagged_questions)
    if (record?.approverFeedback) setApproverFeedback(record?.approverFeedback)
    if (record?.subSectionQuestions) setSubSectionQuestions(record?.subSectionQuestions)
    if (record?.rejectedQuestions) setRejectedQuestions(record?.rejectedQuestions)
  }, [record])

  useEffect(() => {
    paperQuestionData?.forEach(question => {
      if (question?.status === 'Retired') setHasRetiredQuestions(true)
      if (!question?.qb_permit) setHasCleanupWindowQuestions(true)
    })
  }, [paperQuestionData])

  //access control
  useEffect(() => {
    setReadPermission(Permissions.can(userRole).readAny('papers'))
    setCreatePermission(Permissions.can(userRole).createAny('papers'))
    setEditPermission(Permissions.can(userRole).updateAny('papers'))
    setDeletePermission(Permissions.can(userRole).deleteAny('papers'))
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [readPermission])

  useEffect(() => {
    let code: any = 200
   
    code = CheckUserAccess('papers', 'show', user?.id, record, userRole)
    setErrorCode(code)
  }, [user, record, userRole])

  useEffect(() => {
    if (mcqQuestionsCorrectOptionsList !== undefined && mcqQuestionsCorrectOptionsList?.length > 0 && record !== undefined) {
      setOptionsBalanced(true)
    }
  }, [mcqQuestionsCorrectOptionsList])

  return errorCode === 200 ? (
    <PageHeader
      className="site-page-header-responsive"
      ghost={false}
      title={
        <Space>
          <Title level={4}>
            Paper - {record?.name ? `${record?.name} (PID-${record?.paper_id} )` : `#${record?.paper_id} ${record?.paper_smart_id}`}
          </Title>
          <Tag visible={hasCleanupWindowQuestions} icon={<WarningOutlined />} color="red" style={{ verticalAlign: 'top' }}>
            Contains Questions in Cleanup
          </Tag>
          <Tag visible={hasRetiredQuestions} icon={<WarningOutlined />} color="red" style={{ verticalAlign: 'top' }}>
            Contains Retired Questions
          </Tag>
        </Space>
      }
      extra={[
        <Button
          key="close"
          onClick={() => (record?.status !== 'For Approval' && userRole !== 'papersetter' ? window.history.back() : push('/papers'))}
          icon={<Icons.LeftOutlined />}
        >
          Back
        </Button>,
        <>
          {(userRole === 'srmanager' || userRole === 'admin') && mcqQuestionsCorrectOptionsList !== undefined ? (
            <>
              {!record?.available_for_use && (
                <Button
                  type="default"
                  key="reactivate_paper"
                  disabled={record?.available_for_use}
                  onClick={() => {
                    if (record?.id !== undefined) {
                      mutatePaperStatus({ id: record?.id, resource: 'papers', values: { available_for_use: true } })
                    }
                  }}
                >
                  Enable Paper
                </Button>
              )}

              {record?.available_for_use && (
                <Button
                  danger
                  type="default"
                  key="deactivate_paper"
                  disabled={handleDisablePaperCondition(record)}
                  onClick={() => {
                    if (record?.id !== undefined) {
                      mutatePaperStatus({ id: record?.id, resource: 'papers', values: { available_for_use: false } })
                    }
                  }}
                  icon={<Icons.WarningOutlined />}
                >
                  Disable Paper
                </Button>
              )}
            </>
          ) : null}
        </>,
        record?.id && (
          <Button type="primary" onClick={() => showCleanupQuestions()}>
            Cleanup Questions
          </Button>
        ),

        // paperTemplate && userRole !== 'productmanager' && (
        //   <Button
        //     key="submit for approval"
        //     type="primary"
        //     {...saveButtonProps}
        //     onClick={() => {
        //       handleOnFinish('For Approval')
        //     }}
        //     disabled={parseInt(paperTemplate?.data?.product?.total_questions) !== questionsCreated || rejectedQuestionsFlag}
        //     hidden={paperStatus !== 'Unfilled Paper' && paperStatus !== 'Require Amending'}
        //   >
        //     Submit for Approval
        //   </Button>
        // ),
        !!paperTemplate ||
          (paperStatus !== 'Approved' && (
            <Button
              key="approve"
              type="primary"
              {...saveButtonProps}
              onClick={() => {
                handleOnFinish('Approved')
              }}
              disabled={paperStatus !== 'For Approval' && hasRetiredQuestions && hasCleanupWindowQuestions}
              hidden={userRole !== 'paperapprover' && userRole !== 'admin'}
            >
              Approve
            </Button>
          )),

        record !== undefined &&
        (paperStatus === 'Approved' || record?.product?.total_questions === (record?.questionAnswerKeys?.length || totalFilledQuestionCount)) ? (
          <ExportModal
            exportDataLoading={exportDataLoading}
            modalProps={exportModalProps}
            closeModal={closeExportModal}
            showModal={showExportModal}
            request={record}
            exportData={exportData}
            fetchExportData={fetchExportData}
          />
        ) : null,
        record?.status === 'Approved' ? (
          <DiscriminationIndexFromPaper
            modalProps={DIModalProps}
            close={closeDIModal}
            show={showDIModal}
            questionList={paperQuestionData}
            paper={record}
          />
        ) : (
          <></>
        ),
        userRole === 'admin' || userRole === 'product manager' ? <PaperUsageAnalysis paperId={record?.id} /> : null,
        <Button
          key="edit"
          onClick={() => {
            if (record) edit('papers', record?.id)
          }}
          disabled={disableEditButton(paperStatus, record)}
        >
          Edit
        </Button>,
      ]}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then(() => {
            formProps.form?.resetFields()
          })
        }
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="">{<Tag color={record?.status === 'Approved' ? 'green' : 'geekblue'}>{record?.status}</Tag>}</Descriptions.Item>
        </Descriptions>
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Paper Request">
            <Text

            // onClick={() => {
            //   if (record?.paper_request_id) show('paper_requests', record?.paper_request_id)
            // }}
            >
              {record?.paper_request?.name ?? ''}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item label="Test Event Name">
            <Text
            // size="small"
            // type="link"
            // onClick={() => {
            //   if (record?.test_event_id) show('test_events', record?.test_event_id)
            // }}
            >
              {record?.test_event?.name ?? ''}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item label="Product Name">
            <Text
            // size="small"
            // type="link"
            // onClick={() => {
            //   if (record?.product_id) show('products', record?.product_id)
            // }}
            >
              {record?.product?.name ?? ''}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item label="Date and Time">
            <Space>
              <DateField value={slotData?.date} format="LL" />
              <Tag>
                <Space>
                  <DateField value={slotData?.start_time} format="LT" />
                  <DateField value={slotData?.end_time} format="LT" />
                </Space>
              </Tag>
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Export Count">
            <Space>
              {/* <Badge showZero={true} color="blue" count={true ? 55 : 55} /> */}
              <Badge count={record?.export_count} showZero style={{ backgroundColor: 'blue' }} />
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Candidates Used">
            <Badge count={candidatesUsedCount} showZero style={{ backgroundColor: 'green' }} />
          </Descriptions.Item>
        </Descriptions>
        {/* <b>Stats</b> */}
        {/* <Descriptions size="small" column={3}> */}
        {/* <Descriptions.Item label="Number of Questions Added">{`${subSection?.questionIds?.length || 0} of ${
            subSection?.no_of_questions
          }`}</Descriptions.Item>
          <Descriptions.Item label="Total Marks">{`${subSection?.questionIds?.length * subSection?.mark_per_question || 0} of ${
            subSection?.no_of_questions * subSection?.mark_per_question
          }`}</Descriptions.Item> */}
        {/* </Descriptions> */}
        <Divider style={{ margin: ' 0' }} />
        <Row>
          <Col xs={24} lg={24}>
            {/* <h3>Paper:</h3> */}
            <Card style={{ margin: '24px' }}>
              {paperTemplateSections?.data?.data?.map((section, idx) => {
                const subSections = paperTemplateSubSectionData?.filter((item: IPaperTemplateSubSection) => item.section_id === section?.id)
                //added subsection sorting
                subSections?.sort((a, b) => parseInt(a.name.match(/\d+/)?.[0] ?? '0', 10) - parseInt(b.name.match(/\d+/)?.[0] ?? '0', 10))
                //-----
                return (
                  <div key={section?.id}>
                    <div style={{ textAlign: 'center' }}>
                      <h3 style={{ textDecoration: 'underline' }}>{`Section - ${section?.name}`}</h3>
                    </div>

                    {subSections?.map((subSection: IPaperTemplateSubSection) => {
                      const _subSectionQuestions = subSectionQuestions?.filter((_subsection: any) => _subsection?.id === subSection?.id)[0]
                      return (
                        <SubSections
                          key={subSection?.id}
                          subSection={subSection}
                          _subSectionQuestions={_subSectionQuestions}
                          mcqQuestionsCorrectOptionsList={mcqQuestionsCorrectOptionsList}
                          record={record}
                        />
                      )
                    })}
                  </div>
                )
              })}
            </Card>
            <Form.Item name="updated_by" initialValue={user?.id}>
              <Input type="hidden" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {record?.id && <CleanupQuestionsList paperId={record?.id} modalProps={cleanupQuestionModalProps} close={closeCleanupQuestions} />}
    </PageHeader>
  ) : (
    <ErrorComponent />
  )
}

function SubSections({ subSection, _subSectionQuestions, mcqQuestionsCorrectOptionsList, record }: any) {
  const { data: questionsDetails } = useMany<IQuestion>({
    resource: 'questions',
    ids: _subSectionQuestions?.questionIds,
    queryOptions: {
      enabled: !!_subSectionQuestions?.questionIds,
    },
    metaData: questionMetaData,
  })

  const { data: snapShotQuestions } = useList<IQuestionSnapshots>({
    resource: 'paper_question_snapshots',
    config: {
      hasPagination: false,
      filters: [
        {
          field: 'original_question_uuid',
          operator: 'in',
          value: _subSectionQuestions?.questionIds,
        },
        {
          field: 'paper_id',
          operator: 'eq',
          value: record?.id,
        },
      ],
    },
    queryOptions: {
      enabled: !!_subSectionQuestions?.questionIds && record?.status === 'Approved',
    },
    metaData: {
      fields: [
        'id',
        'title',
        'option_details',
        'original_question_uuid',
        'question_type_id',
        { question: [{ questionByTransilationOf: ['title', 'id', 'question_id', 'option_details'] }] },
      ],
    },
  })

  return (
    <div style={{ padding: '12px 0' }}>
      <div style={{ textAlign: 'center' }}>
        <h4 style={{ textDecoration: 'underline' }}>{`Sub Section - ${subSection?.name}`}</h4>
      </div>
      {console.log(subSection, 'Subsectin details')}
      {subSection?.target_lang && subSection?.base_lang && (
        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
          <Tag color="#fc7f03">Bilingual</Tag>
        </div>
      )}

      <Descriptions size="small" column={3}>
        {/* <Descriptions.Item label="Section Name">{subSection.name}</Descriptions.Item> */}
        <Descriptions.Item label="Subject">{subSection?.subject?.name}</Descriptions.Item>
        <Descriptions.Item label="Report Theme">{subSection?.report_theme?.name ?? 'Not-provided'}</Descriptions.Item>
        <Descriptions.Item label="Theme">{subSection?.theme?.name ?? 'Not-provided'}</Descriptions.Item>
        <Descriptions.Item label="Sub Theme">{subSection?.sub_theme?.name ?? 'Not-provided'}</Descriptions.Item>
        <Descriptions.Item label="Topic">{subSection?.topic?.name ?? 'Not-provided'}</Descriptions.Item>
        <Descriptions.Item label="Number of Questions">{` ${subSection?.no_of_questions}`}</Descriptions.Item>
        <Descriptions.Item label="Mark per Questions">{subSection?.mark_per_question}</Descriptions.Item>
      </Descriptions>

      <Divider style={{ margin: '0 0 12px' }} />
      {_subSectionQuestions?.questionIds?.map((questionId: string, idx: number) => {
        const question =
          record?.status === 'Approved' && snapShotQuestions?.data && snapShotQuestions?.data?.length > 0
            ? snapShotQuestions?.data?.filter(item => item?.original_question_uuid === questionId)[0]
            : questionsDetails?.data?.filter(item => item?.id === questionId)[0]
        const shuffledOptions = mcqQuestionsCorrectOptionsList?.filter((data: any) => data?.question_id === questionId)[0]
        console.log(question, 'Question Details')
        if (shuffledOptions !== undefined && question !== undefined) {
          question['option_details'] = shuffledOptions['option_details']
        }
        // if(question){
        //   question.title = (question && subSection?.target_lang && subSection?.base_lang && question?.questionByTransilationOf?.title)
        //   ? (
        //       <>
        //         {question?.questionByTransilationOf?.title}
        //         <br /><br />
        //         {question?.title}
        //       </>
        //     )
        //   : question?.title;

        // }
        return (
          <div style={{ padding: '0 20px' }} key={`${questionId}${idx}`}>
            <Descriptions size="small" column={1} layout="vertical">
              <Descriptions.Item style={{ whiteSpace: 'pre-wrap' }}>
                {subSection?.target_lang && subSection?.base_lang && question?.questionByTransilationOf?.title ? (
                  <Space direction="vertical" align="start" style={{ width: '100%' }}>
                    <div>
                      <>
                        {`${idx + 1}. `}
                        <RichTextRender content={question?.questionByTransilationOf?.title ?? ''} styles={{ width: '100%', height: undefined }} />
                      </>
                    </div>
                    <RichTextRender content={question?.title ?? ''} styles={{ width: '100%', height: undefined }} />
                  </Space>
                ) : (
                  <Space align="baseline">
                    {`${idx + 1}. `}
                    <RichTextRender content={question?.title ?? ''} styles={{ width: 'max', height: undefined }} />
                  </Space>
                )}
              </Descriptions.Item>
              <Descriptions.Item>
                {question?.option_details && question?.question_type_id === 'MCQ' && (
                  <MCQOptions question={question} isBilingual={subSection?.target_lang && subSection?.base_lang} />
                )}
                {question?.option_details && question?.question_type_id === 'Match' && <MatchOptions question={question} />}
              </Descriptions.Item>
            </Descriptions>
          </div>
        )
      })}
      <Divider style={{ margin: '16px 0 4px' }} />
    </div>
  )
}

const MCQOptions = ({ question, isBilingual }: any) => {
  const [value, setValue] = useState(1)

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value)
  }
  return (
    // <Radio.Group onChange={e => onChange(e)} value={value} >
    <Radio.Group onChange={e => onChange(e)} value={undefined} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {question?.option_details?.map((option: any, idx: number) => {
        if (!!option?.option_image_id) {
          const publicUrl = nhost.storage.getPublicUrl({ fileId: option?.option_image_id })
          return (
            <Radio key={`${question?.id}${idx}`} value={idx + 1}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {publicUrl && <img width={100} src={publicUrl} />}
                {option?.option_flag && (
                  <Tag
                    color={
                      option?.option_flag.toLowerCase() === 'right answer'
                        ? 'green'
                        : option?.option_flag.toLowerCase() === 'most wrong'
                        ? 'red'
                        : 'blue'
                    }
                  >
                    {option.option_flag}
                  </Tag>
                )}
              </div>
            </Radio>
          )
        } else {
          return (
            <Radio key={`${question?.id}${idx}`} value={idx + 1} defaultChecked={false}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <RichTextRender
                  content={
                    isBilingual
                      ? `${option?.option_text} - (${question?.questionByTransilationOf?.option_details[idx]?.option_text})`
                      : option?.option_text
                  }
                  styles={{ width: undefined, height: undefined }}
                />
                {option?.option_flag && (
                  <Tag
                    color={
                      option?.option_flag.toLowerCase() === 'right answer'
                        ? 'green'
                        : option?.option_flag.toLowerCase() === 'most wrong'
                        ? 'red'
                        : 'blue'
                    }
                  >
                    {option.option_flag}
                  </Tag>
                )}
              </div>
            </Radio>
          )
        }
      })}
    </Radio.Group>
  )
}

const MatchOptions = ({ question }: any) => {
  interface romanType {
    [key: number]: string
  }
  interface alphabetsType {
    [key: number]: string
  }
  const roman: romanType = { 1: 'i', 2: 'ii', 3: 'iii', 4: 'iv', 5: 'v', 6: 'vi', 7: 'vii', 8: 'viii' }
  const alphabets: alphabetsType = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h' }

  return (
    <div>
      <Table
        style={{ display: 'inline-block', minWidth: '300px' }}
        showHeader={false}
        size="small"
        bordered
        columns={[
          {
            title: 'Left Label',
            key: `left_label_text${question?.id}`,
            dataIndex: 'left_label_text',
            render: (text, record, index) => (
              <Space align="baseline">
                {`${roman[index + 1]})`}
                <RichTextRender
                  content={text}
                  styles={{
                    width: undefined,
                    height: undefined,
                    textAlign: 'center',
                  }}
                />
              </Space>
            ),
          },
          {
            title: 'Right Label',
            key: `right_label_text${question?.id}`,
            dataIndex: 'right_label_text',
            render: (text, record, index) => (
              <Space align="baseline">
                {`${alphabets[index + 1]})`}
                <RichTextRender
                  content={text}
                  styles={{
                    width: undefined,
                    height: undefined,
                    textAlign: 'center',
                  }}
                />
              </Space>
            ),
          },
        ]}
        dataSource={question?.option_details}
        pagination={false}
      />
    </div>
  )
}
